import { render } from "./TableButtonInfo.vue?vue&type=template&id=57b9f9ca"
import script from "./TableButtonInfo.vue?vue&type=script&lang=js"
export * from "./TableButtonInfo.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__